export default __webpack_public_path__ + "locales/ru/ArchiveDialog.json?hash=5b8be8dfe155e3e0e194c6a77ce93102";